export default __webpack_public_path__ + "static/media/Field Sales Management.783f11d5.png";